import { render, staticRenderFns } from "./DemoModal.vue?vue&type=template&id=e1294dd0&scoped=true"
import script from "./DemoModal.vue?vue&type=script&lang=js"
export * from "./DemoModal.vue?vue&type=script&lang=js"
import style0 from "./DemoModal.vue?vue&type=style&index=0&id=e1294dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1294dd0",
  null
  
)

export default component.exports